import { useState, useEffect } from 'react';
import axios from 'axios';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', orange: '#e65100', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const stars = ['அஸ்வினி','பரணி','கிருத்திகை','ரோகிணி','மிருகசீரிஷம்','திருவாதிரை','புனர்பூசம்','பூசம்','ஆயில்யம்','மகம்','பூரம்','உத்திரம்','அஸ்தம்','சித்திரை','சுவாதி','விசாகம்','அனுஷம்','கேட்டை','மூலம்','பூராடம்','உத்திராடம்','திருவோணம்','அவிட்டம்','சதயம்','பூரட்டாதி','உத்திரட்டாதி','ரேவதி'];

const matchTable = [
  [0,0,1,1,1,0,1,1,0,0,1,1,1,0,1,1,0,0,1,1,1,0,1,1,0,0,1],
  [0,0,0,1,1,1,0,1,1,0,0,1,1,1,0,1,1,0,0,1,1,1,0,1,1,0,0],
];

const DhinaPoruthamPage = () => {
  const [star1, setStar1] = useState(0);
  const [star2, setStar2] = useState(0);
  const [result, setResult] = useState(null);

  const calc = () => {
    const diff = ((star2 - star1) + 27) % 27;
    const revDiff = ((star1 - star2) + 27) % 27;
    const goodForward = [1,2,3,4,5,7,8,9,11,13,15,18,20,24,25,26].includes(diff);
    const goodReverse = [1,2,3,4,5,7,8,9,11,13,15,18,20,24,25,26].includes(revDiff);
    setResult({ diff, revDiff, ok: goodForward, revOk: goodReverse, s1: stars[star1], s2: stars[star2] });
  };

  const selStyle = { width: '100%', padding: '8px', borderRadius: '6px', border: '1px solid #ccc', fontSize: '0.8rem' };

  return (
    <div style={{ background: T.bg, minHeight: '80vh', padding: '10px' }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '10px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1rem', fontWeight: 900 }}>💑 தினப் பொருத்தம்</h1>
        <div style={{ color: '#c8e6c9', fontSize: '0.7rem' }}>Daily Star Compatibility</div>
      </div>

      <div style={{ background: T.cream, padding: '12px', borderRadius: '10px', border: '1px solid ' + T.border }}>
        <div style={{ marginBottom: '8px' }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 700, color: T.greenDk }}>ஆண் நட்சத்திரம்</label>
          <select value={star1} onChange={e => setStar1(parseInt(e.target.value))} style={selStyle}>
            {stars.map((s, i) => <option key={i} value={i}>{i+1}. {s}</option>)}
          </select>
        </div>
        <div style={{ marginBottom: '8px' }}>
          <label style={{ fontSize: '0.75rem', fontWeight: 700, color: T.greenDk }}>பெண் நட்சத்திரம்</label>
          <select value={star2} onChange={e => setStar2(parseInt(e.target.value))} style={selStyle}>
            {stars.map((s, i) => <option key={i} value={i}>{i+1}. {s}</option>)}
          </select>
        </div>
        <button onClick={calc} style={{ width: '100%', padding: '10px', background: T.greenDk, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 800, cursor: 'pointer' }}>பொருத்தம் பார் / Check</button>
      </div>

      {result && (
        <div style={{ background: result.ok ? '#e8f5e9' : '#ffebee', padding: '14px', borderRadius: '10px', marginTop: '10px', textAlign: 'center' }}>
          <div style={{ fontSize: '2rem' }}>{result.ok ? '✅' : '❌'}</div>
          <div style={{ fontSize: '1rem', fontWeight: 800, color: result.ok ? T.greenDk : '#c62828' }}>
            {result.ok ? 'பொருத்தம் உள்ளது!' : 'பொருத்தம் இல்லை'}
          </div>
          <div style={{ fontSize: '0.75rem', color: T.maroon, marginTop: '6px' }}>
            {result.s1} → {result.s2}: {result.diff} எண்ணிக்கை ({result.ok ? 'நல்லது' : 'தோஷம்'})
          </div>
          <div style={{ fontSize: '0.75rem', color: T.maroon }}>
            {result.s2} → {result.s1}: {result.revDiff} எண்ணிக்கை ({result.revOk ? 'நல்லது' : 'தோஷம்'})
          </div>
        </div>
      )}
    </div>
  );
};

export default DhinaPoruthamPage;